export interface NumericInputOptions {
  min?: number;
  max?: number;
  step?: number;
  allowDecimals?: boolean;
  allowSign?: boolean;
  decimalPrecision?: number;
  decimalSeparator?: string[];
  autocompleteToDecimalPrecision?: boolean;
  allowPercentage?: boolean;
}
